import { useBaseForm } from "../../components/fx";
import { useRoleFormStore } from "../../controllers/RoleFormController";

const Role = () => {
    const { renderForm } = useBaseForm({ storeHook: useRoleFormStore });
    return (
        <>
            {renderForm()}
        </>
    );
}

export default Role;
